<template>
  <v-container fluid>
    <v-btn icon @click="$router.back()">
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
    <span class="display-1 pl-3" id="title">得意先一覧</span>

    <v-row align="center" justify="center" dense>
      <v-col cols="12" xl="12" dense>
        <v-card v-if= "!isSystemAdmin" flat outlined class="ma-5 pa-3">
          <div class="subtitle-2 mb-2">
            <v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon>
            <span class="primary--text">得意先管理機能について</span>
          </div>
          <p class="caption">
              この機能はシステム管理者のみ利用できる機能です。<br>
          </p>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if= "isSystemAdmin" align="center" justify="center" dense>
      <v-col cols="12">
        <div>
          <v-text-field
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            placeholder="検索"
            filled
          ></v-text-field>
        </div>
      </v-col>

      <v-col cols="12" xl="12" dense>
        総件数：{{items.length}}件
      </v-col>

      <v-col cols="12" xl="12" dense>
        <v-data-table
          :headers="headers"
          :items="items"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :search="search"
          :sort-by="['CompanyID']"
          :loading="loading"
          loading-text="読込中"
          no-data-text="データがありません。"          
          no-results-text="検索条件に該当するデータがありません。"                  
          hide-default-footer
          @page-count="pageCount = $event"
          @click:row="selectCompany"
          fixed-header
        >
          <template v-slot:item.PaymentOfficeID="{ item }">
            <v-avatar v-if="item.PaymentOfficeID" size="24" color="success">
              <v-icon color="white" small>mdi-check</v-icon>
            </v-avatar>
          </template>
          <template v-slot:item.Ratio="{ item }">
            <span v-if="item.Ratio != null && item.Ratio !== 100">{{ item.Ratio }}</span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-row v-if= "isSystemAdmin" align="center" justify="center" dense>
      <v-col cols="10" lg="10" md='10' sm='10' xs="10">
        <v-pagination
         v-model="page"
         :total-visible="totalVisible"
         :length="pageCount"
         color="amber darken-1 black--text"
        light 
        circle
        @input="onPageChange">
        </v-pagination>
      </v-col>
      <v-col cols="4" lg="2"  md='4' sm='4' xs="6">
        <v-select
          :value="itemsPerPage"
          :items = "itemsPerPageList"
          label="1ページの行数"
          @input="itemsPerPage = $event"
        ></v-select>
      </v-col>
    </v-row>

    <v-dialog
      v-model="editCompany"
      persistent
      max-width="90%"
    >
      <v-card outlined class="py-2">
        <v-card-title>
          得意先詳細
        </v-card-title>
        <v-card-text>
          <!-- 第1行: 会社ID、会社名、依頼種別 -->
          <v-row dense class="mb-2">
            <v-col cols=4>
              <v-row dense>
                <v-col cols=4 dense class="font-weight-bold">会社ID</v-col>
                <v-col cols=8 dense>{{company.CompanyID}}</v-col>
              </v-row>
            </v-col>
            <v-col cols=4>
              <v-row dense>
                <v-col cols=4 dense class="font-weight-bold">会社名</v-col>
                <v-col cols=8 dense>{{company.Name}}</v-col>
              </v-row>
            </v-col>
            <v-col cols=4>
              <v-row dense>
                <v-col cols=4 dense class="font-weight-bold">依頼種別</v-col>
                <v-col cols=8 dense>{{company.AnalizeTypeGroup}}</v-col>
              </v-row>
            </v-col>
          </v-row>
          <!-- 第2行: 郵便番号 -->
          <v-row dense class="mb-2">
            <v-col cols=4>
              <v-row dense>
                <v-col cols=4 dense class="font-weight-bold">郵便番号</v-col>
                <v-col cols=8 dense>{{company.Zip}}</v-col>
              </v-row>
            </v-col>
          </v-row>
          <!-- 第3行: 住所（住所1、住所2、住所3） -->
          <v-row dense class="mb-2">
            <v-col cols=4>
              <v-row dense>
                <v-col cols=4 dense class="font-weight-bold">住所１</v-col>
                <v-col cols=8 dense>{{company.Address1}}</v-col>
              </v-row>
            </v-col>
            <v-col cols=4>
              <v-row dense>
                <v-col cols=4 dense class="font-weight-bold">住所２</v-col>
                <v-col cols=8 dense>{{company.Address2}}</v-col>
              </v-row>
            </v-col>
            <v-col cols=4>
              <v-row dense>
                <v-col cols=4 dense class="font-weight-bold">住所３</v-col>
                <v-col cols=8 dense>{{company.Address3}}</v-col>
              </v-row>
            </v-col>
          </v-row>
          <!-- 第4行: 電話番号、FAX番号 -->
          <v-row dense class="mb-2">
            <v-col cols=4>
              <v-row dense>
                <v-col cols=4 dense class="font-weight-bold">電話番号</v-col>
                <v-col cols=8 dense>{{company.Tel}}</v-col>
              </v-row>
            </v-col>
            <v-col cols=4>
              <v-row dense>
                <v-col cols=4 dense class="font-weight-bold">FAX番号</v-col>
                <v-col cols=8 dense>{{company.FAX}}</v-col>
              </v-row>
            </v-col>
            <v-col cols=4>
              <v-row dense>
                <v-col cols=4 dense class="font-weight-bold">担当者</v-col>
                <v-col cols=8 dense>{{company.PIC}}</v-col>
              </v-row>
            </v-col>
          </v-row>
          <!-- 第5行: 請求先コード、請求先事業所コード -->
          <v-row dense class="mb-2">
            <v-col cols=4>
              <v-row dense>
                <v-col cols=4 dense class="font-weight-bold">請求先コード</v-col>
                <v-col cols=8 dense>{{company.PaymentCompanyID}}</v-col>
              </v-row>
            </v-col>
            <v-col cols=4>
              <v-row dense>
                <v-col cols=4 dense class="font-weight-bold">請求先事業所コード</v-col>
                <v-col cols=8 dense>{{company.PaymentOfficeID}}</v-col>
              </v-row>
            </v-col>
          </v-row>
          <!-- 第6行: 掛け率、登録日、更新日 -->
          <v-row dense class="mb-2">
            <v-col cols=4>
              <v-row dense>
                <v-col cols=4 dense class="font-weight-bold">掛け率</v-col>
                <v-col cols=8 dense>{{company.Ratio}}</v-col>
              </v-row>
            </v-col>
            <v-col cols=4>
              <v-row dense>
                <v-col cols=4 dense class="font-weight-bold">登録日</v-col>
                <v-col cols=8 dense>{{formatDate(company.createdAt)}}</v-col>
              </v-row>
            </v-col>
            <v-col cols=4>
              <v-row dense>
                <v-col cols=4 dense class="font-weight-bold">更新日</v-col>
                <v-col cols=8 dense>{{formatDate(company.updatedAt)}}</v-col>
              </v-row>
            </v-col>
          </v-row>
          
          <!-- 事業所一覧 -->
          <v-divider class="my-4"></v-divider>
          <v-row>
            <v-col cols=12>
              <h3 class="mb-3">事業所一覧</h3>
              <v-data-table
                :headers="officeHeaders"
                :items="offices"
                :items-per-page="300"
                hide-default-footer
                dense
                height="300"
                fixed-header 
              >
                <template v-slot:item.OfficeID="{ item }">
                  {{ getOfficeIdSuffix(item.OfficeID) }}
                </template>
                <template v-slot:item.Address1="{ item }">
                  {{ [item.Address1, item.Address2, item.Address3].filter(Boolean).join(' ') }}
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn rounded color="body-2 amber darken-1 font-weight-bold"  @click="cancel()" class="mx-2 mb-5">
            <v-icon class="mr-2">mdi-close</v-icon>閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    </v-container>
</template>

<script>
import { fetchAllCompanys } from '../utils/utils'
import { API, graphqlOperation } from "aws-amplify"
import { officeByCompany } from '../graphql/queries'


export default {

  name: "MainteCompany",
  mixins:[],
  head: {
    title: { inner: '得意先一覧'},
  },
  data() {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 100,
      itemsPerPageList: [ 50,100, ],
      totalVisible: 7,
      search: '',
      loading: false, 

      items: [],
      headers: [
        {
          text: '会社ID',
          align: 'start',
          value: 'CompanyID',
          class: "grey darken-2 white--text",
          width: "15%",
          sortable: true 
        },
        {
          text: '会社名',
          align: 'start',
          value: 'Name',
          class: "grey darken-2 white--text",
          width: "25%" ,
          sortable: true
        },
        {
          text: '住所',
          align: 'start',
          value: 'Address1',
          class: "grey darken-2 white--text",
          width: "30%",
          sortable: false 
        },
        {
          text: '電話番号',
          align: 'start',
          value: 'Tel',
          class: "grey darken-2 white--text",
          width: "15%",
          sortable: false 
        },
        {
          text: '依頼種別',
          align: 'start',
          value: 'AnalizeTypeGroup',
          class: "grey darken-2 white--text",
          width: "15%",
          sortable: false 
        },
        {
          text: '請求先',
          align: 'center',
          value: 'PaymentOfficeID',
          class: "grey darken-2 white--text",
          width: "10%",
          sortable: false 
        },
        {
          text: '掛率',
          align: 'start',
          value: 'Ratio',
          class: "grey darken-2 white--text",
          width: "10%",
          sortable: false 
        },
      ],
      editCompany: false,

      company: {},
      offices: [],
      officeHeaders: [
        {
          text: '事業所ID',
          align: 'start',
          value: 'OfficeID',
          class: "grey darken-2 white--text",
          width: "10%",
          sortable: true
        },
        {
          text: '事業所名',
          align: 'start',
          value: 'Name',
          class: "grey darken-2 white--text",
          width: "40%",
          sortable: true
        },
        {
          text: '住所',
          align: 'start',
          value: 'Address1',
          class: "grey darken-2 white--text",
          width: "40%",
          sortable: false
        },
        {
          text: '電話番号',
          align: 'start',
          value: 'Tel',
          class: "grey darken-2 white--text",
          width: "10%",
          sortable: false
        },
      ],


    }
  },
  filters: {
  },
  computed: {
    isAdmin () {
      return this.$store.state.isAdmin
    },
    isSystemAdmin : function() {
      return this.$store.state.isSystemAdmin
    },
    isSuperUser : function() {
      return this.$store.state.isSuperUser
    },
  },
  mounted: async function () {
    this.initialize()
  },
  methods: {
    initialize: async function() {
      try {
        this.items = await fetchAllCompanys()
      } catch (error) {
        console.error('データの取得に失敗しました:', error)
        this.items = []
      }
    },
    selectCompany: function(data) {
      this.company.id = data.id
      this.company.Name = data.Name
      this.company.CompanyID = data.CompanyID
      this.company.Zip = data.Zip
      this.company.Address1 = data.Address1
      this.company.Address2 = data.Address2
      this.company.Address3 = data.Address3
      this.company.Tel = data.Tel
      this.company.FAX = data.FAX
      this.company.PIC = data.PIC
      this.company.PaymentCompanyID = data.PaymentCompanyID
      this.company.PaymentOfficeID = data.PaymentOfficeID
      this.company.AnalizeTypeGroup = data.AnalizeTypeGroup
      this.company.Ratio = data.Ratio
      this.company.createdAt = data.createdAt
      this.company.updatedAt = data.updatedAt
      this.loadOffices(data.CompanyID)
      this.editCompany = true
    },



    formatDate: function(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleString('ja-JP', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    onPageChange: function() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    loadOffices: async function(companyID) {
      try {
        const result = await API.graphql(graphqlOperation(officeByCompany, {
          CompanyID: companyID,
          limit: 300
        }))
        this.offices = result.data.officeByCompany.items
      } catch (error) {
        console.error('事業所データの取得に失敗しました:', error)
        this.offices = []
      }
    },
    getOfficeIdSuffix: function(officeId) {
      if (!officeId) return ''
      return officeId.slice(-5)
    },
    cancel: function() {
      this.editCompany = false
      this.offices = []
    }
  }
};
</script>